import { fetchEmailNotification, downloadEmailNotificationCsv } from '../services/napi';
import {
  EMAIL_NOTIFICATION_FETCH_SUCCESS,
  DOWNLOAD_EMAIL_NOTIFICATION_SUCCESS
} from '../constant/actionType';

export function fetchEmailNotifications() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await fetchEmailNotification(projectId);
      dispatch({
        data: response.data.emails,
        type: EMAIL_NOTIFICATION_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function downloadEmailNotification() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await downloadEmailNotificationCsv(projectId);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `emailNotification.csv`);
    document.body.appendChild(link);
    link.click();

    dispatch({
      data: response.data,
      type: DOWNLOAD_EMAIL_NOTIFICATION_SUCCESS
    });
  };
}
